<template>
  <el-drawer
    custom-class="bgy-drawer-wrapper"
    v-bind="$attrs"
    v-on="$listeners"
    :title="title"
    :visible.sync="visible"
    :wrapperClosable="false"
    :size="width"
    :append-to-body="true"
    @close="closeDrawer"
  >
    <div class="bgy-drawer-content">
      <slot></slot>
    </div>

    <div
      class="bgy-drawer-footer"
      v-if="showFooter"
    >
      <slot name="footer">
        <div class="footer-box">
          <slot name="footer-left">
            <div class="footer-box-left"></div>
          </slot>
          <slot name="footer-right">
            <div class="footer-box-right">
              <template v-if="showCloseButton">
                <el-button
                  @click="closeFn"
                  type="primary"
                  plain
                >{{ closeButtonText }}</el-button>
              </template>
              <template v-else>
                <el-button
                  @click="cancelFn"
                  v-if="showCancelButton"
                >{{ cancelButtonText }}</el-button>
                <el-button
                  type="primary"
                  v-if="showConfirmButton"
                  @click="confirmFn"
                >{{ confirmButtonText }}</el-button>
              </template>
            </div>
          </slot>
        </div>
      </slot>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'Drawer',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 520
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    closeButtonText: {
      type: String,
      default: '关闭'
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    confirmButtonText: {
      type: String,
      default: '确定'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set() {
        this.$emit('update:show', false);
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    closeFn() {
      this.$emit('update:show', false);
    },
    cancelFn() {
      this.$emit('cancel');
    },
    confirmFn() {
      this.$emit('confirm');
    },
    closeDrawer() {
      this.$emit('closeDrawer');
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.bgy-drawer-wrapper) {
  .el-drawer__header {
    height: 46px;
    margin-bottom: 0;
    padding: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f2f6fc;

    span {
      color: #303133;
      font-size: 16px;
    }
  }

  .el-drawer__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .bgy-drawer-content {
    flex: 1;
    padding: 20px;
    padding-top: 15px;
    overflow-y: auto;
  }

  .bgy-drawer-footer {
    flex-shrink: 0;
    padding: 15px 20px;
    border-top: 1px solid #ebeef5;

    .footer-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100%;

      .footer-box-right {
      }
    }
  }
}
</style>
